import Vue from 'vue'

import 'xe-utils'
import VXETable from 'vxe-table'
import './vex-table-variables.scss'
import utils from '../utils/index'

VXETable.formats.mixin({
  currency({ cellValue }) {
    return utils.formatCurrency(cellValue)
  },
})

Vue.use(VXETable)
// 给 vue 实例挂载全局窗口对象，属性名称随意定义，例如：$XModal
Vue.prototype.$modal = VXETable.modal